/**
 * Two-image banner – whole-cell navigation when `data-link` is set (clicks outside inner links).
 * One document-level click handler so multiple section instances do not stack listeners.
 */
(function () {
  'use strict';

  function setCellCursors() {
    document.querySelectorAll('.slideshow__two-images-cell[data-link]').forEach(function (cell) {
      cell.style.cursor = 'pointer';
    });
  }

  function onDocumentClick(e) {
    var cell = e.target.closest('.slideshow__two-images-cell[data-link]');
    if (!cell || !cell.dataset.link) return;
    if (e.target.closest('a')) return;
    window.location.href = cell.dataset.link;
  }

  if (!window.__sectionTwoImageBannerBound) {
    window.__sectionTwoImageBannerBound = true;
    document.addEventListener('click', onDocumentClick);
  }

  function boot() {
    setCellCursors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
